module.exports = __webpack_public_path__ + "static/media/old-homepage.c8e2d959.png";